import FirstStep from './1'
import SecondStep from './2'
import ThirdStep from './3'
import FourStep from './4'
import FiveStep from './5'

const Forms = [FirstStep, SecondStep, ThirdStep, FourStep, FiveStep]

export { Forms as default }
